const restApi = (url, options = {}) => {
  const restUrl = url
  const config = options

  const request = async (method, url, route, options = {}, body = null) => {
    try {
      url = route ? `${url}/${route}` : url

      const init = {
        method: method,
        headers: new Headers({
          'Content-Type': 'application/json',
          'X-WP-Nonce': options.nonce
        }),
        body
      }

      const response = await fetch(url, init)

      if (!response.ok) {
        const errorText = await response.text().catch(() => null)

        throw new Error(
          JSON.stringify({
            message: 'REST API request failed',
            status: response.status,
            statusText: response.statusText,
            url: url,
            method: method,
            bodySent: body,
            serverResponse: errorText
          })
        )
      }

      return await response.json()
    } catch (e) {
      throw new Error(
        JSON.stringify({
          message: 'Network or parsing error',
          originalError: e.message,
          method: method,
          url: url,
          route: route,
          bodySent: body
        })
      )
    }
  }

  return {
    get: async (route = null) => {
      return await request('GET', restUrl, route, config)
    },

    post: async (route = null, body = null) => {
      return await request('POST', restUrl, route, config, body)
    },

    delete: async (route = null, body = null) => {
      return await request('DELETE', restUrl, route, config, body)
    },

    patch: async (route = null, body = null) => {
      return await request('PATCH', restUrl, route, config, body)
    }
  }
}

export default restApi
